"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LoginForm_1 = __importDefault(require("./LoginForm"));
function EmailUpdated(props) {
    return (react_1.default.createElement(LoginForm_1.default, { onSubmit: () => props.gotoLogin(), title: "Email Address Updated" },
        react_1.default.createElement("div", null,
            props.email ? (react_1.default.createElement("p", null,
                "Your email address has been updated to ",
                react_1.default.createElement("strong", null, props.email),
                ".")) : (react_1.default.createElement("p", null, "Your email address has been updated.")),
            react_1.default.createElement("div", { className: "row row-10m margin-top-20" },
                react_1.default.createElement("div", { className: "col-xs-4 col-xs-offset-4 text-center" },
                    react_1.default.createElement("button", { type: "submit", className: "btn btn-login btn-action" }, "Okay"))))));
}
exports.default = EmailUpdated;
